'use client'

import type { ButtonFeaturesFields } from '@maestro/sanity-cms-blocks/blocks/cms-buttons/cms-buttons.types'

import classNames from 'classnames'
import { useMemo } from 'react'

import { Button as UiButton } from '@pearlconvert/ui/components/button'
import { useModalLink } from '@pearlconvert/ui/hooks/use-modal-link'

import '@maestro/sanity-cms-blocks/blocks/cms-buttons/styles/cms-buttons.scss'

export default function CmsButton(props: ButtonFeaturesFields) {
  const { _key, link, type, label, cssClasses } = props
  const { url, handleClick } = useModalLink(link)

  const btnClassName = useMemo(() => classNames(cssClasses), [cssClasses])

  return (
    <UiButton
      key={_key}
      url={url}
      type={type}
      openNewTab={link?.blank}
      className={btnClassName}
      onClick={handleClick}
    >
      {label}
    </UiButton>
  )
}
